/** "Mathematics of Poker" (Chen & Ankenman), Russian translation in three PDF blocks under public/book/. Summaries live in src/content/book.json. */
export type PartId = 'I' | 'II' | 'III' | 'IV' | 'V';

export interface ChapterDef {
  n: number;
  part: PartId;
  /** which PDF (public/book/{block}.pdf) */
  block: 1 | 2 | 3;
  /** physical page of the chapter's first page in that PDF; equals the printed page number */
  page: number;
  /** listed in the translation's contents but its text is not in the PDF */
  missing?: true;
}

export const PARTS: readonly PartId[] = ['I', 'II', 'III', 'IV', 'V'];

const ch = (n: number, part: PartId, block: 1 | 2 | 3, page: number, missing?: true): ChapterDef =>
  missing ? { n, part, block, page, missing } : { n, part, block, page };

export const chapters: readonly ChapterDef[] = [
  ch(1, 'I', 1, 3),
  ch(2, 'I', 1, 15),
  ch(3, 'I', 1, 29),
  ch(4, 'II', 1, 46),
  ch(5, 'II', 1, 62),
  ch(6, 'II', 1, 77),
  ch(7, 'II', 1, 82),
  ch(8, 'II', 1, 100),
  ch(9, 'II', 1, 113),
  ch(10, 'III', 2, 3),
  ch(11, 'III', 2, 19),
  ch(12, 'III', 2, 35),
  ch(13, 'III', 2, 59),
  ch(14, 'III', 2, 71),
  ch(15, 'III', 2, 85),
  ch(16, 'III', 2, 103),
  ch(17, 'III', 2, 127),
  ch(18, 'III', 2, 149),
  ch(19, 'III', 2, 171),
  ch(20, 'III', 2, 193),
  ch(21, 'III', 2, 215, true),
  ch(22, 'IV', 3, 3),
  ch(23, 'IV', 3, 21),
  ch(24, 'IV', 3, 32),
  ch(25, 'IV', 3, 40),
  ch(26, 'V', 3, 50),
  ch(27, 'V', 3, 65),
  ch(28, 'V', 3, 83),
  ch(29, 'V', 3, 97),
  ch(30, 'V', 3, 111),
];

export const chaptersInPart = (part: PartId): ChapterDef[] =>
  chapters.filter((c) => c.part === part);
export const chapterByN = (n: number): ChapterDef | undefined => chapters.find((c) => c.n === n);
/** chapters whose text exists in the PDFs */
export const readableChapters = chapters.filter((c) => !c.missing);
/** URL of a chapter's first page in its PDF (opens in the browser's viewer) */
export const chapterUrl = (c: ChapterDef): string =>
  `${import.meta.env.BASE_URL}book/${c.block}.pdf#page=${c.page}`;
